import {useEffect, useState, useRef} from 'react'
import {withRouter} from 'react-router-dom';
import {Breadcrumb, Col, Container, Row} from 'react-bootstrap'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft, faArrowRight, faTruck} from "@fortawesome/free-solid-svg-icons";
import Api from "../../../../services/Api";
import HelperGeneral from "../../../../helpers/HelperGeneral";
import UserInfo from "../../../auth/UserInfo";
import {Button, Empty, Input, Modal, Spin} from 'antd'
import {setGlobalSpinner} from "../../../../services/redux/actions/GeneralAction";
import moment from "moment";
import order_1 from "../../../../assets/order_1.json";
import order_100001 from "../../../../assets/order_100001.json";
import order_100000001 from "../../../../assets/order_100000001.json";
import order_100000004 from "../../../../assets/order_100000004.json";
import order_4 from "../../../../assets/order_4.json";
import Lottie from "react-lottie";
import {trans} from "../../../../helpers/HelperGlobal";
import _ from "lodash";
import {useWindowWidth} from "../../../helpers/useWindowWidth";

const {TextArea} = Input

const Order = (props) => {
    const [orderDetail, setOrderDetail] = useState({})
    const [loading, setLoading] = useState(null)
    const [orders, setOrders] = useState([])
    const [rejectMessage, setRejectMessage] = useState(null)
    const [modal, setModal] = useState({})
    const [modalOpen, setModalOpen] = useState(false)
    const [orderStatusList, setOrderStatusList] = useState(
        [
            { "id": -2, "text": "Taslak" },
            { "id": -1, "text": "Ödeme İşleminde" },
            { "id": 0, "text": "Ödeme Bekliyor" },
            { "id": 1, "text": "İşleme Alındı" },
            { "id": 2, "text": "Paketleniyor" },
            { "id": 3, "text": "Teslimata Hazır" },
            { "id": 4, "text": "Teslimatta" },
            { "id": 5, "text": "Teslim Edildi" },
            { "id": 6, "text": "İptal Edildi" }
        ]
    )
    const windowWidth = useWindowWidth();

    useEffect(() => {
        getOrders();
    }, [])

    const getOrders = () => {
        const user = UserInfo.info();
        setLoading(true)
        Api.getOrders(user.id).then((e) => {
            setLoading(false)
            // const orders = _.reject(e?.data?.result, ['orderStatus', 2])
            setOrders(e?.data?.data)
        }).catch(e => {
            HelperGeneral.alert(e)
            setLoading(false)
        })
    }

    // const orderCommit = (orderId, orderNumber, OrderStatus, Message) => {
    //     setModal({
    //         orderId: orderId,
    //         orderNumber: orderNumber,
    //         OrderStatus: OrderStatus,
    //         Message: Message,
    //     })
    //     setModalOpen(true)
    // }

    const orderIcon = (orderStatus) => {
        if (orderStatus === 5) {
            return (
                <Lottie options={{
                    loop: false,
                    autoplay: true,
                    animationData: order_100001,
                    rendererSettings: {
                        preserveAspectRatio: "xMidYMid slice",
                    },
                }} height={120} width={120}/>
            )
        } else if (orderStatus === 4) {
            return (
                <Lottie options={{
                    loop: true,
                    autoplay: true,
                    animationData: order_1,
                    rendererSettings: {
                        preserveAspectRatio: "xMidYMid slice",
                    },
                }} height={120} width={120}/>
            )
        } else if (orderStatus === 2) {
            return (
                <Lottie options={{
                    loop: true,
                    autoplay: true,
                    animationData: order_100000001,
                    rendererSettings: {
                        preserveAspectRatio: "xMidYMid slice",
                    },
                }} height={windowWidth > 575 ? 120 : 100} width={120}/>
            )
        } else if (orderStatus === 1) {
            return (
                <Lottie options={{
                    loop: true,
                    autoplay: true,
                    animationData: order_100000004,
                    rendererSettings: {
                        preserveAspectRatio: "xMidYMid slice",
                    },
                }} height={120} width={120}/>
            )
        } else if (orderStatus === 6) {
            return (
                <Lottie options={{
                    loop: false,
                    autoplay: true,
                    animationData: order_4,
                    rendererSettings: {
                        preserveAspectRatio: "xMidYMid slice",
                    },
                }} height={120} width={120}/>
            )
        } else {
            return false;
        }
    }

    return (
        <Container className={'p-0'}>
            <Row>
                <Col xs={12}>
                    <Spin spinning={loading}>
                        <Col className={(Object.keys(orderDetail).length !== 0 ? 'box' : ' product-history') + ' orders mb-0'}>
                            {
                                Object.keys(orderDetail).length !== 0 ? (
                                    <>
                                        <h4 className={'mb-2 mb-sm-4 pl-0'}>
                                            <FontAwesomeIcon
                                                icon={faArrowLeft}
                                                style={{cursor: 'pointer', marginRight: '12px'}}
                                                onClick={() => setOrderDetail({})}
                                            /> Sipariş Detayı
                                        </h4>
                                        <Col className={'box shadow-none mb-0 p-0'}>
                                            {/*<Row>*/}
                                            {/*    <Col xs={4} className={'mx-auto d-flex justify-content-center align-items-center'}>*/}
                                            {/*        {orderDetail?.status ? orderIcon(orderDetail?.status) : '-'}*/}
                                            {/*    </Col>*/}
                                            {/*</Row>*/}
                                            {/*<Row className={'mt-2 mt-sm-3'}>*/}
                                            {/*    <Col xs={12} md={5} className={'mx-auto d-flex justify-content-center align-items-center'}>*/}
                                            {/*        <h5>{orderStatusList.find((data) => data?.id === orderDetail?.status)?.text ?? '-'}</h5>*/}
                                            {/*    </Col>*/}
                                            {/*</Row>*/}
                                            {
                                                orderDetail?.shippingMethod === 3 &&
                                                orderDetail?.status === 4 && (
                                                    <>
                                                        <Row className={'mt-2 mt-sm-3'}>
                                                            <Col xs={12} className={'mx-auto d-flex justify-content-center align-items-center'}>
                                                                <img
                                                                    src={require('../../../../assets/images/png/yurtici-kargo-logo.png')}
                                                                    width={70}
                                                                    alt={trans('title')}
                                                                />
                                                            </Col>
                                                        </Row>
                                                        <Row className={'mt-2 mt-sm-3'}>
                                                            <Col xs={12} className={'mx-auto d-flex justify-content-center align-items-center'}>
                                                                <span>Kargo Takip Numarası</span>
                                                            </Col>
                                                        </Row>
                                                        <Row className={'mt-2 mt-sm-3'}>
                                                            <Col xs={12} className={'mx-auto d-flex justify-content-center align-items-center'}>
                                                                *************
                                                            </Col>
                                                        </Row>
                                                    </>
                                                )
                                            }
                                            {/*{*/}
                                            {/*    (orderDetail?.deliveryType === 1 && orderDetail?.deliveryCode !== "") && (*/}
                                            {/*        <>*/}
                                            {/*            <Row className={'mt-2 mt-sm-3'}>*/}
                                            {/*                <Col xs={12} md={4} className={'mx-auto d-flex justify-content-center align-items-center'}>*/}
                                            {/*                    <span>Teslimat Numarası</span>*/}
                                            {/*                </Col>*/}
                                            {/*            </Row>*/}
                                            {/*            <Row className={'mt-2 mt-sm-3'}>*/}
                                            {/*                <Col xs={12} md={4} className={'mx-auto d-flex justify-content-center align-items-center'}>*/}
                                            {/*                    {orderDetail?.deliveryCode}*/}
                                            {/*                </Col>*/}
                                            {/*            </Row>*/}
                                            {/*        </>*/}
                                            {/*    )*/}
                                            {/*}*/}
                                            <Row className={'mt-2 mt-sm-3'}>
                                                <Col xs={12} md={4} className={'mx-auto d-flex justify-content-center align-items-center'}>
                                                    <span>Sipariş Numarası</span>
                                                </Col>
                                            </Row>
                                            <Row className={'mt-2 mt-sm-3'}>
                                                <Col xs={12} md={4} className={'mx-auto d-flex justify-content-center align-items-center'}>
                                                    {orderDetail?.id}
                                                </Col>
                                            </Row>
                                            <Row className={'mt-2 mt-sm-3'}>
                                                <Col xs={12} md={4} className={'mx-auto d-flex justify-content-center align-items-center'}>
                                                    <span>Sipariş Tarihi</span>
                                                </Col>
                                            </Row>
                                            <Row className={'mt-2 mt-sm-3'}>
                                                <Col xs={12} md={4} className={'mx-auto d-flex justify-content-center align-items-center'}>
                                                    {moment(orderDetail?.createdAt).format('DD.MM.YYYY HH:mm:ss')}
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xs={12} className={'mt-4'}>
                                                    <h4>Sipariş Özeti</h4>
                                                    {
                                                        orderDetail?.orderProducts &&
                                                        orderDetail?.orderProducts.map((v2, i2) => (
                                                            <Row
                                                                className={"py-2 px-1"}
                                                                style={{cursor: "pointer"}}
                                                                onClick={() => window.location.href = "/product/" + v2?.productInfo?.slug}
                                                            >
                                                                <Col xs={12} md={2} className={"d-flex justify-content-start align-items-center"}>
                                                                    <img
                                                                        src={v2?.image}
                                                                        className={'img-thumbnail'}
                                                                        style={{
                                                                            width: '100%',
                                                                            maxHeight: windowWidth > 575 ? 120 : 100,
                                                                            objectFit: 'contain'
                                                                        }}
                                                                    />
                                                                </Col>
                                                                <Col xs={12} md={10} className={"d-flex justify-content-start align-items-center"}>
                                                                    <Row>
                                                                        <Col xs={12}>
                                                                            {v2?.name}
                                                                        </Col>
                                                                        <Col xs={12}>
                                                                            <b>{v2?.quantity} Adet</b>
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                            </Row>
                                                        ))
                                                    }
                                                </Col>
                                                <Col xs={12} className={'mt-4'}>
                                                    <h4>Teslimat Bilgileri</h4>
                                                    {/*{*/}
                                                    {/*    orderDetail?.deliveryType === 1 && (*/}
                                                    {/*        <>*/}
                                                    {/*            <Row className={"p-0 pt-3 p-sm-3"}>*/}
                                                    {/*                <Col xs={12}>*/}
                                                    {/*                    <b>Eczane Bilgisi</b>*/}
                                                    {/*                </Col>*/}
                                                    {/*                <hr/>*/}
                                                    {/*                <Col xs={12}>*/}
                                                    {/*                    <Row>*/}
                                                    {/*                        <Col xs={12} md={3}>*/}
                                                    {/*                            <b>Adı : </b>*/}
                                                    {/*                        </Col>*/}
                                                    {/*                        <Col xs={12} md={9}>*/}
                                                    {/*                            {orderDetail?.deliveryInfo?.accountDetail?.accountName}*/}
                                                    {/*                        </Col>*/}
                                                    {/*                    </Row>*/}
                                                    {/*                    <Row>*/}
                                                    {/*                        <Col xs={12} md={3}>*/}
                                                    {/*                            <b>Adresi : </b>*/}
                                                    {/*                        </Col>*/}
                                                    {/*                        <Col xs={12} md={9}>*/}
                                                    {/*                            {orderDetail?.deliveryInfo?.accountDetail?.addressLine}*/}
                                                    {/*                        </Col>*/}
                                                    {/*                    </Row>*/}
                                                    {/*                    <Row>*/}
                                                    {/*                        <Col xs={12} md={3}>*/}
                                                    {/*                            <b>Telefon Numarası : </b>*/}
                                                    {/*                        </Col>*/}
                                                    {/*                        <Col xs={12} md={9}>*/}
                                                    {/*                            {orderDetail?.deliveryInfo?.accountDetail?.phoneNumber}*/}
                                                    {/*                        </Col>*/}
                                                    {/*                    </Row>*/}
                                                    {/*                </Col>*/}
                                                    {/*            </Row>*/}

                                                    {/*            <Row className={"p-0 pt-3 p-sm-3"}>*/}
                                                    {/*                <Col xs={12}>*/}
                                                    {/*                    <b>Alıcı Bilgisi</b>*/}
                                                    {/*                </Col>*/}
                                                    {/*                <hr/>*/}
                                                    {/*                <Col xs={12}>*/}
                                                    {/*                    <Row>*/}
                                                    {/*                        <Col xs={12} md={3}>*/}
                                                    {/*                            <b>Adı : </b>*/}
                                                    {/*                        </Col>*/}
                                                    {/*                        <Col xs={12} md={9}>*/}
                                                    {/*                            {orderDetail?.deliveryInfo?.receiverName} {orderDetail?.deliveryInfo?.receiverSurname}*/}
                                                    {/*                        </Col>*/}
                                                    {/*                    </Row>*/}
                                                    {/*                    <Row>*/}
                                                    {/*                        <Col xs={12} md={3}>*/}
                                                    {/*                            <b>Telefon Numarası : </b>*/}
                                                    {/*                        </Col>*/}
                                                    {/*                        <Col xs={12} md={9}>*/}
                                                    {/*                            {orderDetail?.deliveryInfo?.receiverPhone}*/}
                                                    {/*                        </Col>*/}
                                                    {/*                    </Row>*/}
                                                    {/*                    <Row>*/}
                                                    {/*                        <Col xs={12} md={3}>*/}
                                                    {/*                            <b>E-posta Adresi : </b>*/}
                                                    {/*                        </Col>*/}
                                                    {/*                        <Col xs={12} md={9}>*/}
                                                    {/*                            {orderDetail?.deliveryInfo?.receiverEmail}*/}
                                                    {/*                        </Col>*/}
                                                    {/*                    </Row>*/}
                                                    {/*                    <Row>*/}
                                                    {/*                        <Col xs={12} md={3}>*/}
                                                    {/*                            <b>Kimlik Numarası : </b>*/}
                                                    {/*                        </Col>*/}
                                                    {/*                        <Col className={"col-12 col-md-9"}>*/}
                                                    {/*                            {orderDetail?.deliveryInfo?.receiverIdentityNumber}*/}
                                                    {/*                        </Col>*/}
                                                    {/*                    </Row>*/}
                                                    {/*                </Col>*/}
                                                    {/*            </Row>*/}
                                                    {/*        </>*/}
                                                    {/*    )*/}
                                                    {/*}*/}
                                                    {
                                                        orderDetail?.shippingMethod === 3 && (
                                                            <>
                                                                <Row className={"py-2 px-1"}>
                                                                    <Col xs={12} md={3} className={"d-flex justify-content-start align-items-center"}>
                                                                        <b>Teslimat adresi</b>
                                                                    </Col>
                                                                    <Col xs={12} md={9} className={"d-flex justify-content-start align-items-center"}>
                                                                        <Row>
                                                                            <Col xs={12} className={"h-100"}>{orderDetail?.userFirstName + ' ' + orderDetail?.userLastName}</Col>
                                                                            <Col xs={12} className={"h-100"}>{orderDetail?.userInvoiceAddress}</Col>
                                                                            {/*<Col xs={12} className={"h-100"}>{orderDetail?.billingAddress?.addressLine2}</Col>*/}
                                                                            {/*<Col xs={12} className={"h-100"}>{orderDetail?.billingAddress?.city} / {orderDetail?.shippingAddress?.county}</Col>*/}
                                                                        </Row>
                                                                    </Col>
                                                                </Row>
                                                                {/*<hr/>*/}
                                                                {/*<Row className={"py-2 px-1"}>*/}
                                                                {/*    <Col xs={12} md={3} className={"d-flex justify-content-start align-items-center"}>*/}
                                                                {/*        <b>Fatura adresi</b>*/}
                                                                {/*    </Col>*/}
                                                                {/*    <Col xs={12} md={9} className={"d-flex justify-content-start align-items-center"}>*/}
                                                                {/*        <Row>*/}
                                                                {/*            <Col xs={12} className={"h-100"}>{orderDetail?.userFirstName + ' ' + orderDetail?.userLastName}</Col>*/}
                                                                {/*            <Col xs={12} className={"h-100"}>{orderDetail?.userInvoiceAddress}</Col>*/}
                                                                {/*            /!*<Col xs={12} className={"h-100"}>{orderDetail?.billingAddress?.addressLine2}</Col>*!/*/}
                                                                {/*            /!*<Col xs={12} className={"h-100"}>{orderDetail?.billingAddress?.city} / {orderDetail?.shippingAddress?.county}</Col>*!/*/}
                                                                {/*        </Row>*/}
                                                                {/*    </Col>*/}
                                                                {/*</Row>*/}
                                                            </>
                                                        )
                                                    }
                                                </Col>

                                                {/*{*/}
                                                {/*    orderDetail?.orderStatus === 1 && orderDetail?.deliveryType === 1 && (*/}
                                                {/*        <>*/}
                                                {/*            <Col xs={12} className={'mt-4'}>*/}
                                                {/*                <Row>*/}
                                                {/*                    <Col xs={12} md={6} className={"mx-auto"}>*/}
                                                {/*                        <Button*/}
                                                {/*                            onClick={() => orderCommit(orderDetail?.id, orderDetail?.orderNumber, 100000002, "Siparişi iptal etmek istediğinize emin misiniz?")}*/}
                                                {/*                            className={'btn text-white btn-danger  w-100  '}*/}
                                                {/*                            style={{*/}
                                                {/*                                border: 'none',*/}
                                                {/*                                borderRadius: 3,*/}
                                                {/*                                height: 46,*/}
                                                {/*                            }}*/}
                                                {/*                        >Siparişi iptal et</Button>*/}
                                                {/*                    </Col>*/}
                                                {/*                </Row>*/}
                                                {/*            </Col>*/}

                                                {/*            {*/}
                                                {/*                modalOpen && (*/}
                                                {/*                    <Modal*/}
                                                {/*                        centered={true}*/}
                                                {/*                        onCancel={() => {*/}
                                                {/*                            setModalOpen(false)*/}
                                                {/*                            setModal({})*/}
                                                {/*                        }}*/}
                                                {/*                        visible={modalOpen}*/}
                                                {/*                        onOk={() => {*/}
                                                {/*                            if (rejectMessage === null && modal?.OrderStatus === 100000002) {*/}
                                                {/*                                HelperGeneral.alert("Mesajınızı giriniz.", "error")*/}
                                                {/*                            } else {*/}
                                                {/*                                const data = {*/}
                                                {/*                                    orderId: modal?.orderId,*/}
                                                {/*                                    orderNumber: modal?.orderNumber,*/}
                                                {/*                                    isPaymentApproved: true,*/}
                                                {/*                                    OrderStatus: modal?.OrderStatus,*/}
                                                {/*                                    cancelDescription: rejectMessage*/}
                                                {/*                                };*/}
                                                {/*                                setLoading(true)*/}
                                                {/*                                Api.orderCommit(data).then(r => {*/}
                                                {/*                                    setLoading(false)*/}
                                                {/*                                    getOrders();*/}
                                                {/*                                    setModalOpen(false)*/}
                                                {/*                                    setModal({})*/}
                                                {/*                                    setRejectMessage(null)*/}
                                                {/*                                    setOrderDetail({})*/}
                                                {/*                                }).catch((e) => {*/}
                                                {/*                                    setLoading(false)*/}
                                                {/*                                    HelperGeneral.alert(e)*/}
                                                {/*                                })*/}
                                                {/*                            }*/}
                                                {/*                        }}*/}
                                                {/*                    >*/}
                                                {/*                        {*/}
                                                {/*                            modal?.OrderStatus === 1 && (*/}
                                                {/*                                <p>{modal?.Message}</p>*/}
                                                {/*                            )*/}
                                                {/*                        }*/}
                                                {/*                        {*/}
                                                {/*                            modal?.OrderStatus === 100000002 && (*/}
                                                {/*                                <>*/}
                                                {/*                                    <p>{modal?.Message}</p>*/}
                                                {/*                                    <TextArea className={"mt-3"} onChange={(e) => {*/}
                                                {/*                                        setRejectMessage(e?.target?.value)*/}
                                                {/*                                    }} placeholder={"* Siparişinizi neden iptal ediyorsunuz?"}*/}
                                                {/*                                              rows={4}/>*/}
                                                {/*                                </>*/}
                                                {/*                            )*/}
                                                {/*                        }*/}

                                                {/*                    </Modal>*/}
                                                {/*                )*/}
                                                {/*            }*/}
                                                {/*        </>*/}
                                                {/*    )*/}
                                                {/*}*/}
                                            </Row>
                                        </Col>
                                    </>
                                ) : (
                                    <Container className={'p-0'}>
                                        <h4 className={'mb-4'}>Siparişlerim</h4>
                                        {
                                            orders.map((v, i) => (
                                                <Row
                                                    className={'order-item mx-1'}
                                                    onClick={() => setOrderDetail(v)}
                                                >
                                                    <Col xs={12} md={3} className={'d-flex justify-content-center justify-content-md--start align-items-center mb-2 mb-sm-4 m-md-0'}>
                                                        {
                                                            v?.orderProducts &&
                                                            v?.orderProducts?.map((v2, i2) => (
                                                                <img
                                                                    src={v2?.image}
                                                                    className={'img-thumbnail'}
                                                                    style={{
                                                                        width: 70,
                                                                        height: 70,
                                                                        borderRadius: '50%',
                                                                        marginLeft: i2 === 1 ? -20 : 0
                                                                    }}
                                                                />
                                                            ))
                                                        }
                                                        {/*{*/}
                                                        {/*    v?.orderProducts &&*/}
                                                        {/*    v?.orderProducts.length > 2 && (*/}
                                                        {/*        <div*/}
                                                        {/*            className={"d-flex justify-content-center align-items-center shadow"}*/}
                                                        {/*            style={{*/}
                                                        {/*                width: 70,*/}
                                                        {/*                height: 70,*/}
                                                        {/*                borderRadius: '50%',*/}
                                                        {/*                background: '#eaeaea',*/}
                                                        {/*                marginLeft: -20,*/}
                                                        {/*                fontSize: 18*/}
                                                        {/*            }}*/}
                                                        {/*        >*/}
                                                        {/*            {v?.orderProducts?.length - 2} +*/}
                                                        {/*        </div>*/}
                                                        {/*    )*/}
                                                        {/*}*/}
                                                    </Col>

                                                    <Col xs={12} md={2} className={'d-flex justify-content-center align-items-center mb-2 mb-sm-4 m-md-0'}>
                                                        <Row className={'h-100'}>
                                                            <Col
                                                                xs={12}
                                                                className={'text-center d-flex justify-content-center align-items-center'}
                                                            >
                                                                <span>Sipariş Tarihi</span>
                                                            </Col>
                                                            <Col
                                                                xs={12}
                                                                className={'text-center d-flex justify-content-center align-items-center'}
                                                            >
                                                                {moment(v?.createdAt).format('DD.MM.YYYY HH:mm:ss')}
                                                            </Col>
                                                        </Row>
                                                    </Col>

                                                    <Col xs={12} md={2} className={'d-flex justify-content-center align-items-center mb-2 mb-sm-4 m-md-0'}>
                                                        <Row className={'h-100'}>
                                                            <Col xs={12} className={'text-center d-flex justify-content-center align-items-center'}>
                                                                <span>Sipariş Numarası</span>
                                                            </Col>
                                                            <Col xs={12} className={'text-center d-flex justify-content-center align-items-center'}>
                                                                {v?.id}
                                                            </Col>
                                                        </Row>
                                                    </Col>

                                                    <Col xs={12} md={4} className={'d-flex justify-content-center align-items-center mb-2 mb-sm-4 m-md-0'}>
                                                        {v?.shippingMethod === 3 ? 'Adrese Teslim' : 'Eczaneden Teslim'}
                                                    </Col>

                                                    {/*<Col xs={12} md={2} className={'d-flex justify-content-center align-items-center mb-2 mb-sm-4 m-md-0'}>*/}
                                                    {/*    {orderStatusList.find((data) => data?.id === v?.status)?.text ?? '-'}*/}
                                                    {/*</Col>*/}

                                                    <Col xs={12} md={1} className={'d-flex justify-content-center align-items-center'}>
                                                        <FontAwesomeIcon icon={faArrowRight}/>
                                                    </Col>
                                                </Row>
                                            ))
                                        }

                                        {
                                            !loading && orders?.length < 1 && (
                                                <Empty
                                                    description={'Sipariş bulunamadı'}
                                                />
                                            )
                                        }
                                    </Container>
                                )
                            }
                        </Col>
                    </Spin>
                </Col>
            </Row>
        </Container>
    );
}

export default withRouter(Order);
